/**
 * Utility functions for downloading AI request logs
 */

export const downloadRequestLog = async (apiUrl: string, requestId: string) => {
  try {
    const response = await fetch(apiUrl);

    if (!response.ok) {
      throw new Error(`Failed to download log: ${response.status}`);
    }

    const logData = await response.json();

    // Create a blob and download it
    const blob = new Blob([JSON.stringify(logData, null, 2)], {
      type: "application/json",
    });

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `ai-log-${requestId}.json`;
    document.body.appendChild(a);
    a.click();

    // Cleanup
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);

    return logData;
  } catch (error) {
    console.error("Error downloading request log:", error);
    throw error;
  }
};
